@form-border-color: @ig-grey-100;
@input-border-color: #cbd4d5;
@mark-bg-color: #f3d1d3;
@font-size: 16px;
@btn-size: 52px;

:host {
  box-sizing: border-box;
  display: block;
  font-size: @font-size;
}

form {
  border: 5px solid @form-border-color;
  display: flex;
  height: @btn-size;

  input[type='search'] {
    border: 1px solid @input-border-color;
    font-weight: 400;
    font-size: inherit;
    padding: 0 12px;
    width: 100%;

    &:focus {
      outline: 0;
    }
  }

  button[type='submit'] {
    background-color: @ig-red;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: @btn-size 0 0;
    cursor: pointer;
    padding: 0;
    width: @btn-size;

    &:hover {
      background-color: @ig-red-600;
    }
  }
}

.search-results {
  border: 1px solid @input-border-color;
  border-bottom: 0;
  box-shadow: 0 5px 0 0 @ig-red;
  padding: 20px 17px;
  margin: 0;

  li {
    display: block;
    line-height: 22px;
    margin-bottom: 8px;
    font-weight: 500;
    word-break: break-all;
    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: @ig-grey-900;
    display: block;
    text-decoration: none;

    &:hover {
      color: @ig-red-600;
      text-decoration: underline;
    }
  }

  mark {
    background-color: @mark-bg-color;
    color: inherit;
  }
}
